/**
 * Shared formatting utilities
 */

/**
 * Format a number as US currency (no decimals)
 */
export const formatCurrency = (value: number): string => {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  }).format(value)
}

/**
 * Format a number as US currency with decimals
 */
export const formatCurrencyWithDecimals = (value: number, decimals: number = 2): string => {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals
  }).format(value)
}

/**
 * Format a number with locale-specific thousands separators
 */
export const formatNumber = (value: number): string => {
  return new Intl.NumberFormat('en-US').format(value)
}

/**
 * Format currency with smart decimal handling:
 * - Values under $100 show 2 decimal places ($2.40, $99.99)
 * - Values $100+ show no decimals ($100, $2,500)
 */
export const formatCurrencySmart = (value: number): string => {
  const absValue = Math.abs(value)
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: absValue < 100 ? 2 : 0,
    maximumFractionDigits: absValue < 100 ? 2 : 0
  }).format(value)
}
